"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const FairTrade = createSVGIcon(
  <>
    <path
      d="M17 14.48C17 11.983 12 4 12 4s-5 7.983-5 10.48C7 16.976 9.239 19 12 19s5-2.024 5-4.52"
      fill="#D4D9E4"
    />
    <path stroke="#312921" d="M3 14.5 21 14.5" />
  </>,
  "Fair trade",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Fair Trade",
    fill: "none",
    className: legacyIconCls(),
  }
);
